module.exports = __webpack_public_path__ + "static/gm_logo-ebf0947434de366328949163dfd02904.svg";